import axios from '../javascript/custom-axios';
const V1 = '/v1';
const RESOURCE_NAME = '/posts';
const RESOURCE_NAME_ACADEMY = '/academy';

export default {
  likePost(id) {
    return axios.post(`${V1}${RESOURCE_NAME}/${id}/likes`);
  },

  unLikePost(id) {
    return axios.delete(`${V1}${RESOURCE_NAME}/${id}/likes`);
  },

  getPostLikes(id) {
    return axios.get(`${V1}${RESOURCE_NAME}/${id}/likes`);
  },

  commentFeed(id, body) {
    return axios.post(`${V1}${RESOURCE_NAME}/${id}/comments`, body);
  },

  getPostComments(id, Page, PageSize) {
    return axios.get(
      `${V1}${RESOURCE_NAME}/${id}/comments?Page=${Page}&PageSize=${PageSize}`
    );
  },

  getCommentAnswer(id, Page, PageSize, ParentId) {
    return axios.get(
      `${V1}${RESOURCE_NAME}/${id}/comments?Page=${Page}&PageSize=${PageSize}&parentId=${ParentId}`
    );
  },

  getLikedUsers(id, page = 1, pageSize = 50) {
    return axios.get(
      `${V1}${RESOURCE_NAME}/${id}/likes?Page=${page}&PageSize=${pageSize}`
    );
  },

  likeComment(id) {
    return axios.post(`${V1}${'/comments'}/${id}/likes`);
  },

  unLikeComment(id) {
    return axios.delete(`${V1}${'/comments'}/${id}/likes`);
  },

  sharePost(body) {
    return axios.post(`${V1}${RESOURCE_NAME}/sharepost`, body);
  },

  getTagList() {
    return axios.get(`${V1}/tags/tagList`);
  },

  addTag(tagName) {
    return axios.post(`${V1}/tags`, { TagName: tagName });
  },

  pinPost(postId, postOrder) {
    return axios.put(`${V1}${RESOURCE_NAME}/pin/${postId}/${postOrder}`);
  },

  unPinPost(postId) {
    return axios.put(`${V1}${RESOURCE_NAME}/unpin/${postId}`);
  },

  deletePost(postId) {
    return axios.delete(`${V1}${RESOURCE_NAME}/delete/${postId}`);
  },

  complainPost(body) {
    return axios.post(`${V1}/reports/create/`, body);
  },

  deleteComment(id, commentId) {
    return axios.delete(`${V1}${RESOURCE_NAME}/${id}/comments/${commentId}`);
  },

  deleteCommentChild(id) {
    return axios.delete(`${V1}/comments/delete/${id}`);
  },

  createPost(body) {
    return axios.post(`${V1}${RESOURCE_NAME}/create`, body);
  },

  getAcademyLastContent(page, pageSize, type = '') {
    if (type != '')
      return axios.get(
        `${V1}${RESOURCE_NAME}${RESOURCE_NAME_ACADEMY}?type=${type}&Page=${page}&PageSize=${pageSize}&OnlyPrivate=false`
      );
    else
      return axios.get(
        `${V1}${RESOURCE_NAME}${RESOURCE_NAME_ACADEMY}?Page=${page}&PageSize=${pageSize}&OnlyPrivate=false`
      );
  },

  getAcademyCategory() {
    return axios.get(`${V1}/categories/treeview?Id=62a1aa366e569d6087ec1b68`);
  },

  getAcademySearch(page, pageSize, search, sortKey, dateFilter, categoryIds) {
    return axios.get(
      `${V1}${RESOURCE_NAME}${RESOURCE_NAME_ACADEMY}?dateFilter=${dateFilter}&Search=${search}&sortKey=${sortKey}&categoryIds=${categoryIds}&Page=${page}&PageSize=${pageSize}&OnlyPrivate=false`
    );
  },

  getPostDetail(id) {
    return axios.get(`${V1}${RESOURCE_NAME}?Id=${id}`);
  },

  getPostViews(id) {
    return axios.get(`${V1}${RESOURCE_NAME}/${id}/views`);
  },

  setPostViews(id) {
    return axios.post(`${V1}${RESOURCE_NAME}/${id}/views`);
  },

  updatePost(body) {
    return axios.put(`${V1}${RESOURCE_NAME}/update`, body);
  },

  /**
   * Request for Vizgo Academy.
   * @param {*} parameters 
   * @returns {Promise}
   */
  requestForVizgo(query) {
    return axios.get(`${V1}/vizgo`, {
      params: {
        url: query
      }
    });
  },

  async getVizgoContent(
    member,
    isAssigned = 0,
    search = '',
    categoryId = '',
    page = 0,
    pageSize = 15
  ) {
    const key = 'BTX7S-S5VXY-AKD1U';
    const url =
      process.env.VUE_APP_VIZGO_BASE_URL +
      `/v1/External/Bat/Trainings?key=${key}&member=${member}&categoryId=${categoryId}&isAssigned=${isAssigned}&search=${search}&Page=${page}&PageSize=${pageSize}`;

    return this.requestForVizgo(url)
  },

  async getVizgoCategories(sort = 0) {
    const url =
      process.env.VUE_APP_VIZGO_BASE_URL +
      `/v1/External/Bat/Categories?sortDesc=${sort}`;

      return this.requestForVizgo(url)
  },

  async getCertificates(member) {
    const key = 'AFTXS-2FSXY-8DCKZ';
    const url =
      process.env.VUE_APP_VIZGO_BASE_URL +
      `/v1/External/Bat/Certificates?key=${key}&member=${member}`;

    return this.requestForVizgo(url)
  },
};
